import {ApiArticle, ApiBlogData} from "#/src/definitions/ApiDefinitions";
import {ArticleCard} from "#/src/components/ArticleCard";
import React, {useEffect, useState} from "react";
import {useData} from "vike-react/useData";
import {Sort} from "#/src/utils/sort-utils";
import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext, DataWrapped, PaginatedRequest} from "#/src/definitions/AppDefinitions";
import AppConstants from "#/src/utils/app-constants";
import queryString from "query-string";
import {composeHeaders, composeQuery} from "#/src/utils/api-request-utils";
import {LoadableButton} from "#/src/components/LoadableButton";
import styled from "@emotion/styled";
import {appendAt} from "#/src/utils/array-utils";

const LoadMoreButton = styled(LoadableButton)`
  min-width: 12em;
`;

const Category = styled.li`
  cursor: pointer;
`;

export function OlderArticles() {
  const pageContext = usePageContext() as AppPageContext;
  const {data: blogData} = useData() as DataWrapped<ApiBlogData>;
  const oldArticles = Sort.byDate(blogData.oldArticles);
  const ad = blogData.adData
    .filter(a => a.placement == "BLOG_POST_PROMO")
    .filter(a => a.theme == (pageContext.user.lightMode ? "LIGHT" : "DARK"))[0];
  if(ad) {
    appendAt(oldArticles, 4, {
      id: ad.id,
      title: ad.description,
      description: ad.alt,
      slug: ad.campaignUrl,
      isAd: true
    });
  }
  const [category, setCategory] = useState<string | null>(null);
  const [articleData, setArticleData] = useState({error: false, data: oldArticles, page: 1, maxPages: 2});
  useEffect(() => {
    if (typeof window == "undefined") {
      return;
    }
    const query = queryString.parse(window.location.search);
    const queryCategory: string = query.category as string;
    if (queryCategory) {
      onCategoryChange(queryCategory);
      setTimeout(() => document.getElementById("older-articles").scrollIntoView(), 150);
    }
  }, [typeof window !== 'undefined' && window.location.search]);

  async function onCategoryChange(category: string | null) {
    setCategory(category);
    if (category == null) {
      setArticleData({...articleData, data: oldArticles, page: 1, maxPages: 2});
      return;
    }
    setArticleData({...articleData, page: 1, maxPages: 1});
    doFetchArticles(1, category).then(res => {
      const newData = res.data;
      if(ad) {
        appendAt(newData, 4, {
          id: ad.id,
          title: ad.description,
          description: ad.alt,
          slug: ad.campaignUrl,
          isAd: true
        });
      }
      setArticleData({...articleData, data: Sort.byDate(newData), maxPages: res.maxPages, error: false})
    }).catch(() => setArticleData({...articleData, error: true}));
  }

  async function onPageFetch() {
    const nextPage = articleData.page + 1;
    return doFetchArticles(nextPage).then(res => {
      const newData = res.data;
      if(ad) {
        appendAt(newData, 4, {
          id: ad.id,
          title: ad.description,
          slug: ad.campaignUrl,
          isAd: true
        });
      }
      setArticleData({...articleData, page: nextPage});
      setArticleData({...articleData, data: [...articleData.data, ...Sort.byDate(newData)], page: res.page, maxPages: res.maxPages, error: false})
    }).catch(() => setArticleData({...articleData, error: true}));
  }

  async function doFetchArticles(page, newCategory = category) {
    const query = composeQuery({page, category: newCategory});
    const result = await fetch(`${AppConstants.API_ROUTE}/blog/history?${query}`, {method: "GET", headers: composeHeaders(pageContext)});
    if (result.ok) {
      const pageData = await result.json() as PaginatedRequest<ApiArticle>;
      return Promise.resolve(pageData);
    }
    return Promise.reject();
  }

  function render() {
    return <section className="article-latest" id={"older-articles"}>
      <div className="container-xxl">
        <div className="row">
          <div className="col-xl-12">
            <div className="title-between flex-wrap mb-7">
              <h2 className="basic-headline">
                Starsze publikacje
              </h2>
              <ul className="nav-category">{renderCategories()}</ul>
            </div>
          </div>
        </div>
        <div className="row">{renderArticles()}</div>
        {renderFetchButton()}
      </div>
    </section>
  }

  function renderCategories() {
    return <>
      <Category className="nav-item" onClick={() => onCategoryChange(null)}>
        <a className={`nav-link ${category == null ? "active" : ""}`} aria-current="page">Wszystko</a>
      </Category>
      {blogData.categories.map(cat => <Category key={cat.name} className="nav-item" onClick={() => onCategoryChange(cat.slug)}>
        <a className={`nav-link ${category == cat.slug ? "active" : ""}`} aria-current="page">{cat.name}</a>
      </Category>)}
    </>
  }

  function renderArticles() {
    if (articleData.error) {
      return <div>Błąd!</div>
    }
    return articleData.data.map((article: ApiArticle) => <div key={article.id} className="col-xl-3 col-sm-6 col-md-6"><ArticleCard article={article} lazy/></div>);
  }

  function renderFetchButton() {
    if (articleData.maxPages <= articleData.page) {
      return <></>
    }
    return <div className={"row justify-content-center"}>
      <div className={"text-center"}>
        <LoadMoreButton className={"btn btn-secondary"} onClick={onPageFetch}>Załaduj więcej</LoadMoreButton>
      </div>
    </div>
  }

  return render();
}